import { ActionTypes } from '../constants';

export default function updateOutboundShippingLanePage(pageNumber: number) {
  return {
    type: ActionTypes.UPDATE_OUTBOUND_SHIPPING_LANES_PAGE,
    payload: pageNumber,
  };
}
